import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["avatar", "remaining"]
  static values = { count: Number }

  connect() {
    this.observer = new ResizeObserver(() => this.fit())
    this.observer.observe(this.element)
    this.fit()
  }

  disconnect() {
    this.observer.disconnect()
  }

  fit() {
    if (this.element.clientWidth === 0) return

    const avatars = this.avatarTargets
    avatars.forEach(avatar => { avatar.hidden = false })
    let visible = avatars.length
    this.updateRemaining(visible)
    while (visible > 1 && this.element.scrollWidth > this.element.clientWidth) {
      avatars[--visible].hidden = true
      this.updateRemaining(visible)
    }
  }

  updateRemaining(visible) {
    const remaining = this.countValue - visible
    this.remainingTarget.hidden = remaining === 0
    this.remainingTarget.textContent = `+${remaining}`
  }
}
